import React, { useEffect } from 'react';
import { SecurityBoundary, PermissionBoundary } from '@vehix/portal/lib/security';
import { logDataAccess } from '@vehix/portal/lib/security/audit';
import { SystemRole } from '@vehix/portal/types';
import { useAuth } from '@vehix/shared/admin/portal-bridge';
import { UserApprovalsTab } from '../../components/UserApprovalsTab';

const UserSetupPage: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      logDataAccess({
        resource: 'user_setup',
        action: 'view',
        metadata: { page: 'setup-users' }
      }).catch(() => {
        /* silent — audit logging should not surface errors */
      });
    }
  }, [user]);

  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='setup-users'
      tenantIsolation={false}
    >
      <div className='flex h-full w-full flex-col overflow-hidden'>
        <PermissionBoundary require={{ resource: 'users', action: 'manage' }}>
          <UserApprovalsTab />
        </PermissionBoundary>
      </div>
    </SecurityBoundary>
  );
};

export default UserSetupPage;
